import { DateTime } from "luxon";
import { appConfig } from "@/config/appConfig";

export function registerGlobalProperties(app) {
    app.config.globalProperties.base_url_masbar = appConfig.baseUrlMasbar;
    app.config.globalProperties.base_url_receiving = appConfig.baseUrlReceiving;
    app.config.globalProperties.base_url_second = appConfig.baseUrlSecond;
    app.config.globalProperties.base_url = appConfig.baseUrl;
    app.config.globalProperties.payment_url = appConfig.paymentUrl;
    app.config.globalProperties.base_url_po = appConfig.baseUrlPo;
    app.config.globalProperties.holding_url = appConfig.holdingUrl;
    app.config.globalProperties.fe_url = appConfig.feUrl;
    app.config.globalProperties.bff = appConfig.bff;

    app.config.globalProperties.formatDate = (dates) => {
        if (!dates) return "-";

        const parsedDate = DateTime.fromFormat(dates, "dd-MM-yyyy");

        if (!parsedDate.isValid) return "-";

        return parsedDate.endOf("day").setLocale("en-gb").toLocaleString();
    };
}
